import { NavLink } from "@/components/NavLink";
import { useLocation } from "react-router-dom";
import {
  Layers,
  FileText,
  CheckSquare,
  BarChart3,
  Settings,
  Calendar,
} from "lucide-react";
import { RitualIcon } from "@/components/ui/RitualIcon";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar";
import { Logo } from "@/components/ui/Logo";
import { AgentAvatar } from "@/components/agent/AgentAvatar";

interface AppSidebarProps {
  organizationId: string;
}

export function AppSidebar({ organizationId }: AppSidebarProps) {
  const { state } = useSidebar();
  const location = useLocation();

  // Custom icon component wrapper for RitualIcon
  const AISetupIcon = () => <RitualIcon size="sm" />;
  
  const navItems = [
    { title: "Feed", url: "/app", icon: Layers },
    { title: "Tasks", url: "/app/tasks", icon: CheckSquare },
    { title: "Library", url: "/app/library", icon: FileText },
    { title: "Schedules", url: "/app/schedules", icon: Calendar },
    { title: "AI Setup", url: "/app/setup", icon: AISetupIcon },
    { title: "Analytics", url: "/app/analytics", icon: BarChart3 },
    { title: "Settings", url: "/app/settings", icon: Settings },
  ];

  const isActive = (path: string) => {
    if (path === "/app") {
      return location.pathname === "/app" || location.pathname === "/app/feed";
    }
    if (path === "/app/library") {
      return location.pathname.startsWith("/app/library") || 
             location.pathname.startsWith("/app/sops") ||
             location.pathname.startsWith("/app/runs");
    }
    return location.pathname === path;
  };
  const isCollapsed = state === "collapsed";

  return (
    <Sidebar className={isCollapsed ? "w-14" : "w-60"}>
      <SidebarContent>
        <div className="p-4 border-b">
          <Logo size={isCollapsed ? "xs" : "sm"} showText={!isCollapsed} />
        </div>

        <SidebarGroup>
          <SidebarGroupLabel>Main</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {navItems.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton asChild>
                    <NavLink
                      to={item.url}
                      end
                      className="flex items-center gap-3 hover:bg-accent/50 transition-colors"
                      activeClassName="bg-accent text-primary font-medium"
                    >
                      <item.icon className="h-4 w-4" />
                      {!isCollapsed && <span>{item.title}</span>}
                    </NavLink>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}
